// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var $$String = require("rescript/lib/js/string.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Js_array = require("rescript/lib/js/js_array.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_string = require("rescript/lib/js/js_string.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Querystringify = require("querystringify");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Role$ReactHooksTemplate = require("../settings/role.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Filters$ReactHooksTemplate = require("../dashboard/filters/filters.res.js");
var Loading$ReactHooksTemplate = require("../dashboard/dashboard/Loading.res.js");
var Pagination$ReactHooksTemplate = require("../common/Pagination.res.js");
var EmailFromId$ReactHooksTemplate = require("../surveys/emailFromId.res.js");
var AuthProvider$ReactHooksTemplate = require("../AuthProvider.res.js");
var ReportSortBar$ReactHooksTemplate = require("../common/ReportSortBar.res.js");
var PaginationUtils$ReactHooksTemplate = require("../common/PaginationUtils.res.js");
var ReportAutomailer$ReactHooksTemplate = require("./reportAutomailer.res.js");
var ReportSortParams$ReactHooksTemplate = require("../common/ReportSortParams.res.js");
var MultipleSelectBox$ReactHooksTemplate = require("../common/MultipleSelectBox.res.js");
var ReportAutomailerModal$ReactHooksTemplate = require("./ReportAutomailerModal.res.js");

function emptyState(param) {
  return {
          name: "",
          header: /* [] */0,
          contents: /* [] */0
        };
}

function noMessage(param) {
  return "";
}

function decodeDownloadReport(json) {
  return Json_decode.field("file_name", Json_decode.string, json);
}

function decodeReportDetails(header, json) {
  return List.map((function (name) {
                return Json_decode.optional((function (param) {
                              return Json_decode.field(name, Json_decode.string, param);
                            }), json);
              }), header);
}

function decode(json) {
  var name = Json_decode.field("name", Json_decode.string, json);
  var header = Json_decode.field("header", (function (param) {
          return Json_decode.list(Json_decode.string, param);
        }), json);
  return {
          name: name,
          header: header,
          contents: Json_decode.field("report_data", (function (param) {
                  return Json_decode.list((function (param) {
                                return decodeReportDetails(header, param);
                              }), param);
                }), json)
        };
}

var ReportData = {
  emptyState: emptyState,
  noMessage: noMessage,
  decodeDownloadReport: decodeDownloadReport,
  decodeReportDetails: decodeReportDetails,
  decode: decode
};

var emptyReports = {
  name: "",
  header: /* [] */0,
  contents: /* [] */0
};

var initialState = {
  loading: true,
  reports: emptyReports,
  toggleFilter: false
};

function reducer(state, x) {
  if (typeof x !== "object") {
    if (x === "FetchReportsInProgress") {
      return {
              loading: true,
              reports: state.reports,
              toggleFilter: state.toggleFilter
            };
    } else {
      return {
              loading: state.loading,
              reports: state.reports,
              toggleFilter: !state.toggleFilter
            };
    }
  } else {
    return {
            loading: false,
            reports: x._0,
            toggleFilter: state.toggleFilter
          };
  }
}

function totalRecord(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

function perPage(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

var emptyPageInfo = {
  total: "1",
  perPage: "1"
};

function fetchFromIds(param) {
  return Js_promise.then_((function (json) {
                return Promise.resolve(Belt_List.fromArray(Json_decode.field("email_from_ids", (function (param) {
                                      return Json_decode.array(EmailFromId$ReactHooksTemplate.decode, param);
                                    }), json)));
              }), Http$ReactHooksTemplate.fetchGetJSON("/api/v1/email_from_ids"));
}

function fetchRoles(param) {
  return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/roles", (function (param) {
                return Json_decode.field("roles", (function (param) {
                              return Json_decode.list(Role$ReactHooksTemplate.decode, param);
                            }), param);
              }));
}

function fetchPlaceholderChips(param) {
  return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/report_automailers/placeholders", (function (param) {
                return Json_decode.field("data", (function (param) {
                              return Json_decode.field("placeholders", (function (param) {
                                            return Json_decode.array(ReportAutomailer$ReactHooksTemplate.decodePlaceholderChip, param);
                                          }), param);
                            }), param);
              }));
}

function ReportView(props) {
  var reportId = props.reportId;
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var match$1 = React.useState(function (param) {
        return emptyPageInfo;
      });
  var setPageInfo = match$1[1];
  var pageInfo = match$1[0];
  var match$2 = React.useState(function (param) {
        return false;
      });
  var setShowAutomailerModal = match$2[1];
  var match$3 = React.useState(function (param) {
        return ReportAutomailer$ReactHooksTemplate.empty();
      });
  var setAutomailerConfig = match$3[1];
  var automailerConfig = match$3[0];
  var match$4 = React.useState(function (param) {
        return /* [] */0;
      });
  var setFromIds = match$4[1];
  var match$5 = React.useState(function (param) {
        return /* [] */0;
      });
  var setPlaceholderChips = match$5[1];
  var match$6 = React.useState(function (param) {
        return /* [] */0;
      });
  var setRoles = match$6[1];
  var match$7 = React.useState(function (param) {
        return /* [] */0;
      });
  var setAutomailerErrors = match$7[1];
  var match$8 = React.useState(function (param) {
        return /* [] */0;
      });
  var setExistingAutomailers = match$8[1];
  var queryParams = Querystringify.parse(props.search);
  var parsedReportId = Belt_Int.fromString(reportId);
  var canShowAutomailerButton = parsedReportId !== undefined ? !state.loading && state.reports.name !== "" : false;
  var match$9 = React.useState(function (param) {
        return /* [] */0;
      });
  var setSortOptions = match$9[1];
  var sortParams = ReportSortParams$ReactHooksTemplate.fromQuery(Js_dict.get(queryParams, "sort_column"), Js_dict.get(queryParams, "sort_order"), "transaction_date", undefined);
  var sortColumnValue = sortParams.sortColumn;
  var sortOrderValue = ReportSortParams$ReactHooksTemplate.sortOrderToQuery(sortParams.sortOrder);
  var x = Js_dict.get(queryParams, "page");
  var currentPage;
  if (x !== undefined && x !== "") {
    var page = Belt_Int.fromString(x);
    currentPage = page !== undefined ? page : 1;
  } else {
    currentPage = 1;
  }
  var fetchKey = String(currentPage) + ":" + sortColumnValue + ":" + sortOrderValue;
  var url = "/api/v1/reports/" + reportId + "?page=" + String(currentPage) + "&sort_column=" + sortColumnValue + "&sort_order=" + sortOrderValue;
  var handlePageChange = function (pageNumber) {
    var pageNo = String(pageNumber);
    RescriptReactRouter.push("/reports/" + reportId + "?page=" + pageNo + "&sort_column=" + sortColumnValue + "&sort_order=" + sortOrderValue);
  };
  var fetchReport = function (param) {
    return Js_promise.then_((function (param) {
                  var headers = param[0];
                  var x = headers.get("Total");
                  var total = x !== null ? (
                      x === null ? undefined : Caml_option.some(x)
                    ) : "1";
                  var x$1 = headers.get("Per-Page");
                  var perPage = x$1 !== null ? (
                      x$1 === null ? undefined : Caml_option.some(x$1)
                    ) : "1";
                  return Js_promise.then_((function (json) {
                                var report = Json_decode.field("report", decode, json);
                                var templateType = Json_decode.field("template_type", (function (param) {
                                        return Json_decode.withDefault("", Json_decode.string, param);
                                      }), json);
                                var sortOptions = Json_decode.field("sort_options", (function (param) {
                                        return Json_decode.withDefault(/* [] */0, (function (param) {
                                                      return Json_decode.list((function (json) {
                                                                    return {
                                                                            key: Json_decode.field("key", Json_decode.string, json),
                                                                            label: Json_decode.field("label", Json_decode.string, json)
                                                                          };
                                                                  }), param);
                                                    }), param);
                                      }), json);
                                return Promise.resolve([
                                            [
                                              report,
                                              templateType,
                                              sortOptions
                                            ],
                                            [
                                              total,
                                              perPage
                                            ]
                                          ]);
                              }), param[1]);
                }), Http$ReactHooksTemplate.fetchGetJSONWithHeader(url));
  };
  var onApplyFilter = function (param) {
    Curry._1(dispatch, "ToggleFilter");
    Curry._1(dispatch, "FetchReportsInProgress");
    Js_promise.then_((function (param) {
            var pageInfo = param[1];
            var perPage = pageInfo[1];
            var total = pageInfo[0];
            var match = param[0];
            var sortOptions = match[2];
            Curry._1(setPageInfo, (function (param) {
                    return {
                            total: total,
                            perPage: perPage
                          };
                  }));
            Curry._1(setSortOptions, (function (param) {
                    return sortOptions;
                  }));
            Curry._1(dispatch, {
                  TAG: "FetchReportsCompleted",
                  _0: match[0]
                });
            return Promise.resolve();
          }), fetchReport());
  };
  var toggleFilter = function (param) {
    Curry._1(dispatch, "ToggleFilter");
  };
  React.useEffect((function (param) {
          Curry._1(dispatch, "FetchReportsInProgress");
          Js_promise.then_((function (param) {
                  var pageInfo = param[1];
                  var perPage = pageInfo[1];
                  var total = pageInfo[0];
                  var match = param[0];
                  var sortOptions = match[2];
                  Curry._1(setPageInfo, (function (param) {
                          return {
                                  total: total,
                                  perPage: perPage
                                };
                        }));
                  Curry._1(dispatch, {
                        TAG: "FetchReportsCompleted",
                        _0: match[0]
                      });
                  Curry._1(setSortOptions, (function (param) {
                          return sortOptions;
                        }));
                  return Promise.resolve();
                }), fetchReport());
        }), [
        currentPage,
        fetchKey
      ]);
  React.useEffect((function (param) {
          Js_promise.$$catch((function (param) {
                  return Promise.resolve();
                }), Js_promise.then_((function (param) {
                      var rolesList = param[1];
                      var ids = param[0];
                      Curry._1(setFromIds, (function (param) {
                              return ids;
                            }));
                      Curry._1(setRoles, (function (param) {
                              return rolesList;
                            }));
                      return Promise.resolve();
                    }), Promise.all([
                        fetchFromIds(),
                        fetchRoles()
                      ])));
        }), []);
  React.useEffect((function (param) {
          Js_promise.$$catch((function (param) {
                  return Promise.resolve();
                }), Js_promise.then_((function (chips) {
                      Curry._1(setPlaceholderChips, (function (param) {
                              return Belt_List.fromArray(chips);
                            }));
                      return Promise.resolve();
                    }), fetchPlaceholderChips()));
        }), []);
  var fetchAutomailers = function (param) {
    return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/report_automailers", (function (param) {
                  return Json_decode.field("data", (function (param) {
                                return Json_decode.field("report_automailers", (function (param) {
                                              return Json_decode.array(ReportAutomailer$ReactHooksTemplate.decode, param);
                                            }), param);
                              }), param);
                }));
  };
  var closeAutomailerModal = function (param) {
    Curry._1(setAutomailerErrors, (function (param) {
            return /* [] */0;
          }));
    Curry._1(setShowAutomailerModal, (function (param) {
            return false;
          }));
  };
  var currentNameTrimmed = ReportAutomailer$ReactHooksTemplate.name(automailerConfig).trim();
  var isNameTaken = currentNameTrimmed !== "" && Belt_List.some(match$8[0], (function (a) {
          return ReportAutomailer$ReactHooksTemplate.name(a).trim() === currentNameTrimmed;
        }));
  var nameTakenErrorStr = isNameTaken ? "Name has already been taken" : "";
  var hasRecipients = Belt_List.length(ReportAutomailer$ReactHooksTemplate.toEmails(automailerConfig)) > 0 || Belt_List.length(Belt_Option.getWithDefault(ReportAutomailer$ReactHooksTemplate.recipientRoleNames(automailerConfig), /* [] */0)) > 0;
  var automailerRecurrence = ReportAutomailer$ReactHooksTemplate.recurrence(automailerConfig);
  var isAutomailerFormValid = currentNameTrimmed.length > 0 && !isNameTaken && automailerRecurrence.preset.length > 0 && ReportAutomailer$ReactHooksTemplate.sendTime(automailerConfig).length > 0 && ReportAutomailer$ReactHooksTemplate.schedule(automailerConfig).length > 0 && ReportAutomailer$ReactHooksTemplate.fromEmail(automailerConfig).trim().length > 0 && hasRecipients && ReportAutomailer$ReactHooksTemplate.isRecurrenceValid(automailerRecurrence) && ReportAutomailer$ReactHooksTemplate.subject(automailerConfig).trim().length > 0 && Belt_List.length(ReportAutomailer$ReactHooksTemplate.reportIds(automailerConfig)) > 0;
  var onAutomailerSubmit = function (param) {
    var params = {};
    params["report_automailer"] = ReportAutomailer$ReactHooksTemplate.encode(automailerConfig);
    Js_promise.$$catch((function (param) {
            return Promise.resolve();
          }), Js_promise.then_((function (response) {
                var status = Json_decode.field("status", (function (param) {
                        return Json_decode.withDefault("failed", Json_decode.string, param);
                      }), response);
                var errors = Belt_Option.getWithDefault(Json_decode.optional((function (param) {
                            return Json_decode.field("errors", (function (param) {
                                          return Json_decode.list(Json_decode.string, param);
                                        }), param);
                          }), response), /* [] */0);
                if (status === "success") {
                  Curry._1(setAutomailerErrors, (function (param) {
                          return /* [] */0;
                        }));
                  Curry._1(setShowAutomailerModal, (function (param) {
                          return false;
                        }));
                  RescriptReactRouter.push("/reports/automailer");
                } else {
                  Curry._1(setAutomailerErrors, (function (param) {
                          return errors;
                        }));
                }
                return Promise.resolve();
              }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/report_automailers", params)));
  };
  var fixedReportOption = parsedReportId !== undefined ? ({
        id: parsedReportId,
        name: state.reports.name,
        timeFrame: undefined
      }) : undefined;
  var headerText = function (input) {
    var split = Js_string.split("(", input);
    var outPut = Belt_List.head(Belt_List.fromArray(split));
    if (outPut !== undefined) {
      return outPut;
    } else {
      return "";
    }
  };
  var tooltipText = function (input) {
    var split = Js_string.split("(", input);
    var outPut = Belt_List.tail(Belt_List.fromArray(split));
    var val = outPut !== undefined ? Js_array.joinWith(" (", Belt_List.toArray(outPut)) : "";
    return Js_string.slice(0, val.length - 1 | 0, val);
  };
  var match$10 = React.useContext(AuthProvider$ReactHooksTemplate.authContext);
  var totalCount = Caml_format.int_of_string(pageInfo.total);
  var perPageCount = Caml_format.int_of_string(pageInfo.perPage);
  var totalPagesCount = PaginationUtils$ReactHooksTemplate.totalPages(totalCount, perPageCount);
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
              children: Caml_option.some(Curry._1(match$10[0], "ShowReport") ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                          children: [
                            state.toggleFilter ? JsxRuntime.jsx(Filters$ReactHooksTemplate.make, {
                                    onClose: toggleFilter,
                                    onApply: onApplyFilter,
                                    showDateFilter: false,
                                    showFilterPills: false
                                  }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                            state.loading ? JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx(Loading$ReactHooksTemplate.make, {
                                          text: "Loading..."
                                        }),
                                    className: "h-screen w-full animated fadeIn"
                                  }) : JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("a", {
                                                            children: JsxRuntime.jsx("img", {
                                                                  className: "custom-back mr-2",
                                                                  src: Image$ReactHooksTemplate.backArrow
                                                                }),
                                                            href: "/reports"
                                                          }),
                                                      JsxRuntime.jsx("h2", {
                                                            children: state.reports.name,
                                                            className: "text-xl font-semibold capitalize"
                                                          })
                                                    ],
                                                    className: "flex items-center"
                                                  }),
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      canShowAutomailerButton ? JsxRuntime.jsx("button", {
                                                              children: "Set up report mail",
                                                              className: "bg-ghostwhite border border-gray-400 rounded-lg flex items-center gap-2 px-4 py-1 text-sm shadow-sm hover:bg-gray-100",
                                                              type: "button",
                                                              onClick: (function (param) {
                                                                  if (parsedReportId === undefined) {
                                                                    return ;
                                                                  }
                                                                  Curry._1(setAutomailerErrors, (function (param) {
                                                                          return /* [] */0;
                                                                        }));
                                                                  var __x = ReportAutomailer$ReactHooksTemplate.empty();
                                                                  var __x$1 = ReportAutomailer$ReactHooksTemplate.setReportIds(__x, {
                                                                        hd: parsedReportId,
                                                                        tl: /* [] */0
                                                                      });
                                                                  var initial = ReportAutomailer$ReactHooksTemplate.setName(__x$1, "Email: " + state.reports.name);
                                                                  Curry._1(setAutomailerConfig, (function (param) {
                                                                          return initial;
                                                                        }));
                                                                  Curry._1(setShowAutomailerModal, (function (param) {
                                                                          return true;
                                                                        }));
                                                                  Js_promise.$$catch((function (param) {
                                                                          return Promise.resolve();
                                                                        }), Js_promise.then_((function (arr) {
                                                                              Curry._1(setExistingAutomailers, (function (param) {
                                                                                      return Belt_List.fromArray(arr);
                                                                                    }));
                                                                              return Promise.resolve();
                                                                            }), fetchAutomailers()));
                                                                })
                                                            }) : null,
                                                      JsxRuntime.jsxs("button", {
                                                            children: [
                                                              JsxRuntime.jsx("img", {
                                                                    className: "h-4",
                                                                    src: Image$ReactHooksTemplate.filterButton
                                                                  }),
                                                              "Filters"
                                                            ],
                                                            className: "inline-flex h-40-px shrink-0 items-center gap-2 rounded-lg border border-gray-400 bg-ghostwhite px-4 text-sm shadow-sm",
                                                            id: "filters",
                                                            onClick: (function (param) {
                                                                Curry._1(dispatch, "ToggleFilter");
                                                              })
                                                          }),
                                                      JsxRuntime.jsx(ReportSortBar$ReactHooksTemplate.make, {
                                                            sortOptions: match$9[0],
                                                            selectedKey: sortColumnValue,
                                                            order: sortParams.sortOrder,
                                                            onChange: (function (column, order) {
                                                                var newSortOrder = ReportSortParams$ReactHooksTemplate.sortOrderToQuery(order);
                                                                RescriptReactRouter.push("/reports/" + reportId + "?page=1&sort_column=" + column + "&sort_order=" + newSortOrder);
                                                              })
                                                          }),
                                                      JsxRuntime.jsx(MultipleSelectBox$ReactHooksTemplate.make, {
                                                            options: {
                                                              hd: "csv",
                                                              tl: {
                                                                hd: "tsv",
                                                                tl: /* [] */0
                                                              }
                                                            },
                                                            placeholder: "Download",
                                                            placeholderClassName: "mr-2",
                                                            handleChange: (function (fileFormat) {
                                                                var download_url = "/api/v1/download_report?id=" + reportId + "&file_format=" + fileFormat + "&sort_column=" + sortColumnValue + "&sort_order=" + sortOrderValue;
                                                                Js_promise.then_((function (file_name) {
                                                                        return Promise.resolve((console.log(file_name), RescriptReactRouter.push("/downloads")));
                                                                      }), Http$ReactHooksTemplate.fetchGetJSONDecode(download_url, decodeDownloadReport));
                                                              }),
                                                            selectedOptions: /* [] */0,
                                                            className: "w-160-px shrink-0 rounded-lg border border-gray-300 bg-pigmentblue px-3 py-0 text-white shadow-sm outline-none h-40-px",
                                                            optionsHoverColor: "hover:bg-spanishgray rounded-lg ",
                                                            listBoxCss: "p-1 rounded-lg "
                                                          })
                                                    ],
                                                    className: "flex shrink-0 items-center gap-3"
                                                  })
                                            ],
                                            className: "flex items-center border-b border-gray-300 px-30-px py-16-px justify-between"
                                          }),
                                      JsxRuntime.jsx(Pagination$ReactHooksTemplate.Bar.make, {
                                            currentPage: currentPage,
                                            totalPages: totalPagesCount,
                                            totalRecords: totalCount,
                                            perPage: perPageCount,
                                            handlePageChange: handlePageChange,
                                            itemLabel: "records",
                                            className: "mx-30-px mb-4"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsxs("table", {
                                                  children: [
                                                    JsxRuntime.jsx("thead", {
                                                          children: JsxRuntime.jsx("tr", {
                                                                children: $$Array.of_list(List.mapi((function (i, header) {
                                                                            var tooltip = tooltipText($$String.capitalize_ascii(header));
                                                                            return JsxRuntime.jsx("th", {
                                                                                        children: JsxRuntime.jsxs("div", {
                                                                                              children: [
                                                                                                tooltip === "" ? $$String.capitalize_ascii(header) : JsxRuntime.jsxs("div", {
                                                                                                        children: [
                                                                                                          JsxRuntime.jsx("p", {
                                                                                                                children: headerText($$String.capitalize_ascii(header)),
                                                                                                                className: "truncate [max-width:150px]"
                                                                                                              }),
                                                                                                          JsxRuntime.jsx("div", {
                                                                                                                children: tooltipText($$String.capitalize_ascii(header)),
                                                                                                                className: "tooltip-container-text custom-tooltip-response-report"
                                                                                                              })
                                                                                                        ],
                                                                                                        className: "tooltip-container"
                                                                                                      }),
                                                                                                JsxRuntime.jsx("img", {
                                                                                                      className: "ml-4-px",
                                                                                                      src: Image$ReactHooksTemplate.heading
                                                                                                    })
                                                                                              ],
                                                                                              className: "flex"
                                                                                            }),
                                                                                        className: "px-4 py-2"
                                                                                      }, String(i));
                                                                          }), state.reports.header)),
                                                                className: "font-medium p-4 bg-ghostwhite text-aurometalsaurus"
                                                              })
                                                        }),
                                                    JsxRuntime.jsx("tbody", {
                                                          children: $$Array.of_list(List.mapi((function (i, x) {
                                                                      return JsxRuntime.jsx("tr", {
                                                                                  children: $$Array.of_list(List.mapi((function (k, step) {
                                                                                              if (step !== undefined) {
                                                                                                return JsxRuntime.jsx("td", {
                                                                                                            children: step,
                                                                                                            className: "px-4 py-2"
                                                                                                          }, String(k));
                                                                                              } else {
                                                                                                return JsxRuntime.jsx("td", {
                                                                                                            children: "",
                                                                                                            className: "px-4 py-2"
                                                                                                          }, String(k));
                                                                                              }
                                                                                            }), x)),
                                                                                  className: "border-b border-bottom-gray-600"
                                                                                }, String(i));
                                                                    }), state.reports.contents))
                                                        })
                                                  ],
                                                  className: "text-left table-auto w-full border-separate text-xs font-medium"
                                                }),
                                            className: "flex px-30-px pb-30-px overflow-x-auto"
                                          })
                                    ]
                                  }),
                            JsxRuntime.jsx(ReportAutomailerModal$ReactHooksTemplate.make, {
                                  show: match$2[0],
                                  config: automailerConfig,
                                  fromIds: match$4[0],
                                  reportOptions: /* [] */0,
                                  placeholderChips: match$5[0],
                                  roles: match$6[0],
                                  isFormValid: isAutomailerFormValid,
                                  onUpdate: (function (config) {
                                      Curry._1(setAutomailerConfig, (function (param) {
                                              return config;
                                            }));
                                    }),
                                  onSubmit: onAutomailerSubmit,
                                  onClose: closeAutomailerModal,
                                  formAction: "create",
                                  fixedReport: fixedReportOption,
                                  validationErrors: match$7[0],
                                  nameTakenError: nameTakenErrorStr
                                })
                          ]
                        }) : JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx(Loading$ReactHooksTemplate.make, {
                                img: Caml_option.some(Image$ReactHooksTemplate.unAuthorized),
                                text: "401: Unauthorized!!",
                                loading: false
                              }),
                          className: "h-screen w-full animated fadeIn"
                        }))
            });
}

var noMessage$1 = "";

var make = ReportView;

exports.ReportData = ReportData;
exports.emptyReports = emptyReports;
exports.initialState = initialState;
exports.reducer = reducer;
exports.totalRecord = totalRecord;
exports.perPage = perPage;
exports.emptyPageInfo = emptyPageInfo;
exports.noMessage = noMessage$1;
exports.fetchFromIds = fetchFromIds;
exports.fetchRoles = fetchRoles;
exports.fetchPlaceholderChips = fetchPlaceholderChips;
exports.make = make;
/* react Not a pure module */
